export default {
  namespaced: true,
  state: {
    lastRoute: null,
    currentRoute: null,
    currentParams: null,
    currentRouteId: null,
    currentRouteProduct: null,
  },
  getters: {
    getLastRoute: (state) => state.lastRoute,
    getCurrentRoute: (state) => state.currentRoute,
    getCurrentParams: (state) => state.currentParams,
    getCurrentRouteId: (state) => state.currentRouteId,
    getCurrentRouteProduct: (state) => state.currentRouteProduct
  },
  mutations: {
    SET_LAST_ROUTE (state, routeName) {
      state.lastRoute = routeName
    },
    // This is set in beforeEach router guard
    SET_CURRENT_ROUTE (state, routeName) {
      state.currentRoute = routeName
    },
    SET_CURRENT_PARAMS (state, params) {
      state.currentParams = params
    },
    SET_CURRENT_ROUTE_ID (state, id) {
      state.currentRouteId = id
    },
    SET_CURRENT_ROUTE_PRODUCT (state, product) {
      state.currentRouteProduct = product
    }
  },
  actions: {}
}
